var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { metaDebug } = options; 
__p+='\n';
 if(metaDebug){ 
__p+='\n  <div>Debug Info:\n  ';
 $.each(metaDebug, function(key, value){ 
__p+='\n    <div><span><strong>'+
((__t=(key))==null?'':__t)+
'</strong></span> : <span> '+
((__t=(JSON.stringify(value) ))==null?'':__t)+
' </span></div>\n  ';
}); 
__p+='\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-debug-info.jst.ejs